import { createStore, buildRootReducer } from '../utils/createStore'
import context from '../context'

let store = null

export function getStore () {
  if (!store) {
    store = createStore(context.reducers)
  }
  return store
}

export function replaceReducers (reducers) {
  store.replaceReducer(buildRootReducer(reducers))
}



// WEBPACK FOOTER //
// ./src/store/index.js